import { createContext } from "react";

export const ActiveProjectsSocketContext = createContext(null);